import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

import { apiClient } from '@copro/api';
import * as Sentry from "@sentry/react";
import { supabaseIntegration } from '@supabase/sentry-js-integration';


Sentry.init({
  enabled: !import.meta.env.VITE_CI,
  dsn: "https://fbc28d03d6709f61f6edebad76e416d5@o4511207283556352.ingest.de.sentry.io/4511241807724624",
  integrations: [
    Sentry.browserTracingIntegration({
      shouldCreateSpanForRequest: (url) => {
        return !url.startsWith(`${import.meta.env.VITE_SUPABASE_URL}/rest`)
      },
    }),
    Sentry.replayIntegration(),
    supabaseIntegration(apiClient, Sentry, {
      tracing: true,
      breadcrumbs: true,
      errors: true,
    }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
});

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<StrictMode>
  <App />
</StrictMode>);